export const BASE_URL = process.env.REACT_APP_API_URL;

export const APP_CONFIG = {
  isCheckMaintenance: true,
} as const;
